module.exports = __webpack_public_path__ + "img/background.364cfb21.png";